import { Paper, Stack, Text } from '@mantine/core';
import React from 'react';

import { OrderType } from './order.types';
import { useGenericContext } from '../../../components/GenericContext';

export function OrderNotesToSellerCard<TOrder extends OrderType>() {
  const order = useGenericContext<TOrder>();

  if (!order.note_to_seller) return null;

  return (
    <Paper withBorder p="xl" radius="md">
      <Stack spacing="md">
        <Text size="md" color="gray.8">
          Notes to Seller
        </Text>

        <Text size="sm" color="gray.8" data-testid="notes-to-seller-text">
          {order.note_to_seller}
        </Text>
      </Stack>
    </Paper>
  );
}
